import { render, staticRenderFns } from "./ClrmTabs.vue?vue&type=template&id=220366e2&scoped=true&"
import script from "./ClrmTabs.vue?vue&type=script&lang=js&"
export * from "./ClrmTabs.vue?vue&type=script&lang=js&"
import style0 from "./ClrmTabs.vue?vue&type=style&index=0&id=220366e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220366e2",
  null
  
)

export default component.exports